import styled from '@emotion/styled'

export const SelectionStyled = styled.select`
  display: inline-block;
  border: none;
  margin-right: 4px;
`
